<template>
  <div class="home">
    <b-container fluid>
      <b-row>
        <b-col>
          <b-row v-if="stato.consulente && !stato.installatore && !stato.admin">
            <b-col>
              <div id="licenza">
                <h2>Licenza:</h2>
                <div v-if="licenza.num_liberi >= 0">
                  <h6>Valida dal {{licenza.da}} al {{licenza.a}}</h6>
                  <h6>Vale per {{licenza.num_installatori}} installator{{licenza.num_installatori == 1 ? 'e' : 'i'}}</h6>
                  <h6>Puoi creare ancora {{licenza.num_liberi}} installator{{licenza.num_liberi == 1 ? 'e' : 'i'}}</h6>
                </div>
                <div v-else>
                  <h6>La licenza che si possiede è scaduta o non è valida per il numero di installatori che si ha.</h6>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="stato.installatore">
            <b-col>
              <div id="clienti_count">
                <h2>Numero di Clienti Creati</h2>
                <hr style="border-color: white">
                <h1>{{clienti_count}}</h1>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="stato.consulente && !stato.installatore && !stato.admin">
            <b-col>
              <div id="clienti">
                <h2>Ultimi Installatori Creati:</h2>
                <hr style="border-color: white">
                <table v-if="installatori.length > 1">
                  <tr v-for="(installatore, index) in installatori" v-bind:key="index">
                    <td>
                      <h6 v-if="index">{{index}})</h6>
                    </td>
                    <td>
                      <h6>{{installatore.denominazione}}</h6>
                    </td>
                    <td>
                      <h6>{{installatore.email}}</h6>
                    </td>
                    <td>
                      <b-button v-if="installatore.id != -1" variant="success" size="sm" style="border: 0; margin: 0; height: 30px; padding: 0px 10px 10px 10px" :to="'installatori/modifica/'+installatore.id"><font-awesome-icon icon="eye" /></b-button>
                    </td>
                  </tr>
                  <!--hr style="border-color: white"-->
                </table>
                <h6 v-else>Non ci sono installatori!</h6>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="stato.installatore">
            <b-col>
              <div id="macchine_count">
                <h2>Numero di Macchine Create</h2>
                <hr style="border-color: white">
                <h1>{{macchine_count}}</h1>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="!stato.admin">
          <section class="todo-wrapper">
                <h2>Cose da Fare:</h2>
            <form @keydown.enter.prevent="">
              <input type="text" class="input-todo" v-bind:class="{ active: new_todo }" placeholder="Scrivi qui un attività da svolgere" v-model="new_todo" v-on:keyup.enter="addItem">
              <div class="btn btn-add" v-bind:class="{ active: new_todo }"  @click="addItem">+</div>
            </form>

            <div v-if="pending.length > 0">
              <p class="status busy">Hai {{ pending.length }} attività da svolgere</p>
              <transition-group name="todo-item" tag="ul" class="todo-list">
                <li v-for="(item) in pending" v-bind:key="item.title">
                  <input class="todo-checkbox" v-bind:id="'item_' + item.id" v-model="item.done" type="checkbox">
                  <label v-bind:for="'item_' + item.id"></label>
                  <span class="todo-text">{{ item.title }}</span>
                  <span class="delete" @click="deleteItem(item)"><font-awesome-icon icon="trash-alt" /></span>
                </li>
              </transition-group>  
            </div> 

            <transition name="slide-fade">
              <p class="status free" v-if="!pending.length" >Non hai nessuna attività da svolgere!</p> 
            </transition> 

            <div v-if="completed.length > 0 && showComplete">
              <p class="status">Attività completate: {{ completedPercentage }}</p>
              <transition-group name="todo-item" tag="ul" class="todo-list archived">
                <li v-for="(item) in completed" v-bind:key="item.title">
                  <input class="todo-checkbox" v-bind:id="'item_' + item.id" v-model="item.done" type="checkbox">
                  <label v-bind:for="'item_' + item.id"></label>
                  <span class="todo-text">{{ item.title }}</span>
                  <span class="delete" @click="deleteItem(item)"><font-awesome-icon icon="trash-alt" /></span>
                </li>
              </transition-group>  
            </div>  
            <div class="control-buttons">
              <div class="btn btn-secondary" v-if="completed.length > 0" @click="toggleShowComplete"><span v-if="!showComplete">Mostra</span><span v-else>Nascondi</span> Completati</div>
              <!--div class="btn btn-secondary" v-if="todoList.length > 0" @click="clearAll">Elimina Tutto</div-->
            </div>
          </section>
        </b-col>
      </b-row>
      <b-row v-if="!stato.admin">
        <b-col>
          <div id="macchine">
            <h2>Ultime Macchine Create:</h2>
            <hr style="border-color: white">
            <table v-if="macchine.length > 1">
              <tr v-for="(macchina, index) in macchine" v-bind:key="index">
                <td>
                  <h6 v-if="index">{{index}})</h6>
                </td>
                <td v-if="!stato.installatore">
                  <h6>{{macchina.installatore}}</h6>
                </td>
                <td>
                  <h6>{{macchina.denominazione}}</h6>
                </td>
                <td>
                  <h6>{{macchina.descrizione}}</h6>
                </td>
                <td>
                  <h6>{{macchina.indirizzo}}</h6>
                </td>
                <td>
                  <h6>{{macchina.data}}</h6>
                </td>
              </tr>
            </table>
            <h6 v-else>Non ci sono macchine!</h6>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="stato.admin">
        <b-col>
          <div id="attivi_count">
            <h2>Numero Utenti già Attivi</h2>
            <hr style="border-color: white">
            <h1>{{attivi_count}}</h1>
          </div>
        </b-col>
        <b-col>
          <div id="attesa_count">
            <h2>Numero Utenti da Attivare</h2>
            <hr style="border-color: white">
            <h1>{{attesa_count}}</h1>
          </div>
        </b-col>
        <b-col>
          <div id="scadenza_count">
            <h2>Numero Utenti in Scadenza</h2>
            <hr style="border-color: white">
            <h1>{{scadenza_count}}</h1>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  data() {
    return {
      licenza: {
        da: '',
        a: '',
        num_installatori: 0,
        num_liberi: -1
      },
      installatori: [],
      macchine: [],
      clienti_count: 0,
      macchine_count: 0,


      todoList: [],
      new_todo: '',
      showComplete: false,

      attivi_count: 0,
      attesa_count: 0,
      scadenza_count: 0,
    }
  },
  created: function(){
    this.loadConsulenteDashboard()
  },
  mounted() {
    this.getTodos()
  },
  methods: {
    loadConsulenteDashboard(){
      var tipo
      if(this.stato.admin)
        tipo = "admin"
      else if(this.stato.installatore)
        tipo = "installatore"
      else if(this.stato.consulente)
        tipo = "consulente"

      Vue.http.post('dashboard/'+tipo, {}, {credentials : true}).then(response => {
        if(response.body.success){
          if(tipo != "admin"){
            this.macchine = [{installatore: "Installatore", denominazione: "Cliente", descrizione: "Descrizione", indirizzo:"Indirizzo", data: "Data"}].concat(response.body.data.macchine)
            this.todoList = response.body.data.todo

            if(tipo == "consulente"){
              this.licenza = response.body.data.licenza
              this.installatori = [{id: -1, denominazione: "Denominazione", email: "E-mail"}].concat(response.body.data.installatori)
            }

            if(tipo == "installatore"){
              this.clienti_count = response.body.data.clienti_count
              this.macchine_count = response.body.data.macchine_count
            }
          }else if(tipo == "admin"){
              this.attesa_count = response.body.data.attesa_count
              this.attivi_count = response.body.data.attivi_count
              this.scadenza_count = response.body.data.scadenza_count
          }
        }else{
          Vue.notify({
            group: 'global',
            title: 'Errore',
            text: response.body.msg,
            type: 'error'
          })
        }
      }, response => {})
    },
    getTodos() {
      if (localStorage.getItem('todo_list')) {
        this.todoList = JSON.parse(localStorage.getItem('todo_list'))
      }
    },
    addItem() {
      if(this.new_todo){
        return Vue.http.post('dashboard/todo/add', {testo: this.new_todo}, {credentials : true}).then(response => {
          if(response.body.success){
            this.new_todo = ''

            this.loadConsulenteDashboard()

            return true
          }else{
            Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
            })

            return false
          }
        }, response => {})
      }

      return false
    },
    deleteItem(item) {
      //this.todoList.splice(this.todoList.indexOf(item), 1)
      return Vue.http.post('dashboard/todo/delete/'+item.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadConsulenteDashboard()

          return true
        }else{
          Vue.notify({
            group: 'global',
            title: 'Errore',
            text: response.body.msg,
            type: 'error'
          })

          return false
        }
      }, response => {})
    },
    toggleShowComplete() {
      this.showComplete = !this.showComplete
    },
    clearAll() {
      this.todoList = []
    }
  },
  watch: {
    todoList: {
      handler: function(updatedList){
        var oldList
        if(localStorage.getItem('todo_list'))
          oldList = JSON.parse(localStorage.getItem('todo_list'))
        else
          oldList = []

        if(oldList.length == updatedList.length){
          for(var i=0; i<oldList.length; i++){
            var e = updatedList.find(el => {
              if(el.id == oldList[i].id)
                return true
              return false
            })

            if(e.done != oldList.done){
              Vue.http.post('dashboard/todo/check/'+e.id, {check: e.done}, {credentials : true}).then(response => {
                if(!response.body.success){
                  Vue.notify({
                    group: 'global',
                    title: 'Errore',
                    text: response.body.msg,
                    type: 'error'
                  })
                }
              }, response => {})
            }
          }
        }

        localStorage.setItem('todo_list', JSON.stringify(updatedList))
      },
      deep: true
    }
  },
  computed:{
    ...mapGetters(['stato']),
    pending: function() {
      return this.todoList.filter(function(item) {
        return !item.done
      })
    },
    completed: function() {
      return this.todoList.filter(function(item) {
        return item.done
      }); 
    },
    completedPercentage: function() {
      return (Math.floor((this.completed.length / this.todoList.length) * 100)) + "%"
    }
  },
}
</script>

<style scoped>
#licenza{
  margin: 20px 20px 20px 0px;
  width: 100%;
  background-image: linear-gradient(to right, #493240, #493240);
  color: white;
  border-radius: 4px;
  padding: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
}

#clienti{
  margin: 20px 20px 20px 0px;
  width: 100%;
  background-image: linear-gradient(to right, #662300, #662300);
  color: white;
  border-radius: 4px;
  padding: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  overflow-x: auto;
}

#macchine{
  margin: 20px 20px 20px 0px;
  width: 100%;
  background-image: linear-gradient(to right, #6c0000, #6c0000);
  color: white;
  border-radius: 4px;
  padding: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  overflow-x: auto;
}

#clienti_count{
  text-align: center;
  margin: 20px 20px 20px 0px;
  width: 100%;
  background-image: linear-gradient(to right, #493240, #493240);
  color: white;
  border-radius: 4px;
  padding: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
}

#macchine_count{
  text-align: center;
  margin: 20px 20px 20px 0px;
  width: 100%;
  background-image: linear-gradient(to right, #662300, #662300);
  color: white;
  border-radius: 4px;
  padding: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
}

#attivi_count{
  text-align: center;
  margin: 20px 20px 20px 0px;
  width: 100%;
  background-image: linear-gradient(to right, #662300, #662300);
  color: white;
  border-radius: 4px;
  padding: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
}

#attesa_count{
  text-align: center;
  margin: 20px 20px 20px 0px;
  width: 100%;
  background-image: linear-gradient(to right, #493240, #493240);
  color: white;
  border-radius: 4px;
  padding: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
}

#scadenza_count{
  text-align: center;
  margin: 20px 20px 20px 0px;
  width: 100%;
  background-image: linear-gradient(to right, #6c0000, #6c0000);
  color: white;
  border-radius: 4px;
  padding: 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
}

table{
  width: 100%;
  border-spacing: 150px;
}

tr{
  border-bottom: 1pt solid white;
}

tr:first-child td{
  padding-top: 0;
  padding-bottom: 10px;
}

td{
  padding-top: 15px;
  padding-bottom: 10px;
}

/* TODO */
.todo-wrapper{
  width: 100%;
  height: calc(100% - 40px);
  max-width: 100%;
  margin: 20px auto 40px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 40px 20px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.05);
  background-color: #009999;
  overflow: hidden;
  position: relative;
  color: white;
}

form{
  overflow: overlay;
}

form label{
  display: block;
  text-align: center;
  font-size: 1.2em;
}

.btn, input {
  line-height: 2em;
  border-radius: 3px;
  border: 0;
  display: inline-block;
  margin: 15px 0;
  padding: 0.2em 1em;
  font-size: 1em;
}

input[type='text'] {
  border: 1px solid #ddd; 
  min-width: 80%;
  transition: all ease-in 0.25s;
}

input:focus{
  outline: none;
  border: 1px solid #a3b1ff;
}

input::placeholder{
  color: rgba(0,0,0,0.3);
  font-style: italic;
}

.btn{
  text-align: center;
  font-weight: bold; 
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
}

.btn-add {
  background: #ddd;
  color: #fefefe;
  border-color: #ddd;
  min-width: 17%;
  pointer-events: none;
  transition: all ease-in 0.25s;
  font-size: 2.2em;
  line-height: 0.5em;
  padding: 0.3em 0.3em;
  float: right;
}

.btn-add.active{
  background: #990000;
  border-color: #990000;
  pointer-events: visible;
}

.btn-add.active:hover{
  background: #99001a;
  border-color: #99001a;
}

.btn-add:active{
  transform: scale(0.95);
}
.control-buttons{
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
}
.btn-secondary{
  display: inline-block;
  position: relative;
  border: 0;
  padding: 0;
  margin: 0 10px;
  background: transparent;
}

.btn-secondary:after{
  position: absolute;
  content: '';
  width: 0;
  height: 3px;
  background-color: #990000;
  bottom: 0px;
  left: 0;
  transition: all ease-in 0.25s;
}

.btn-secondary:hover:after{
  width: 100%;
}

.btn-secondary:hover{
  background: transparent;
}

ul.todo-list{
  padding: 0;
  margin-bottom: 30px;
}

ul.todo-list li{
  position: relative;
  list-style-type: none;
  display: block;
  margin: 10px 0;
  background: white;
  border-radius: 3px;
  padding-left: 38px; /* custom checkbox width + 16 */
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 49px; /* delete button + 5 */ 
  overflow: hidden;
  color: #363636;
}

ul.todo-list.archived li{
  background: #fff;
}

.todo-text{
  position: relative;
  display: inline-block;
  padding: 0 0.5em;
}


ul.todo-list li .delete{
  position: absolute;
  height: 100%;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  cursor: pointer;
  opacity: 0;
  width: 0;
  background-color: #f56468;
  color: #fff;
  transition: all ease-in 0.25s;
  padding: 15px;
}

ul.todo-list li .delete:after{
  position: absolute;
  content: '';
  width: 16px;
  height: 16px;
  top: 50%;
  left: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transform: translate(-50%, -50%) scale(0.5);
  transition: all ease-in 0.25s;
}

ul.todo-list li:hover .delete{
  width: 44px;
  opacity: 1;
}

ul.todo-list li:hover .delete:after{
  transform: translate(-50%, -50%) scale(1);
}
  
.todo-checkbox{
  position: absolute; 
  opacity: 0;
  display: none;
}

.todo-checkbox + label {
  position: absolute;
  cursor: pointer;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border-radius: 2px;
  border: 1px solid #cfdcec;
  background-color: #fff;
}

.todo-checkbox:checked + label:after{
  position: absolute;
  content: '';
  top: 30%;
  left: 50%;
  height: 3px;
  width: 6px;
  border: solid #fc6c48;
  border-width: 0 0 2px 2px;
  transform-origin: center center;
  transform: rotate(-45deg) translate(-50%, -50%);
}

.todo-checkbox:checked + label:after{
  display: block;
}

.todo-checkbox:checked ~ .todo-text{
  color: #888;
  text-decoration: line-through
}

.status.free{
  font-weight: bold;
  text-align: center;
  margin: 40px 0;
}
.status.free img{
  display: block;
  width: 50px;
  margin: 10px auto;
  vertical-align: middle;
}

.todo-item-enter-active, .todo-item-leave-active {
  transition: opacity ease 0.25s, transform ease-in-out 0.3s;
  transform-origin: left center;
}

/* .todo-item-leave-active below version 2.1.8 */
.todo-item-enter, .todo-item-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

 
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease;
}
/* .slide-fade-leave-active below version 2.1.8 */
.slide-fade-enter, .slide-fade-leave-to {  
  transform: scale(1.1);
  opacity: 0;
}


/* Footer */
footer{  
  position: absolute;
  width: 100%;
  text-align: center;
  color: #fff;
  bottom: 20px;
  left: 0;
}

footer a{
  color: #fff;
}
</style>